import httpClient from "@/core/axios";

export default {
    namespaced: true,
    state: {
        invoices: [],
        connector_reservation_id: null
    },
    getters: {
        invoices(state) {
            return state.invoices;
        }
    },
    actions: {
        async fetch(context) {
            return httpClient
                .get("/api/guest/app/:app_uuid/user/invoices")
                .then(data => {
                    context.commit("SET_INVOICES", data.invoices);
                    return data;
                })
                .then(data =>
                    context.commit(
                        "SET_CONNECTOR_ID",
                        data.connector_reservation_id
                    )
                );
        },
        async download(context, id) {
            return httpClient
                .get(`/api/guest/app/:app_uuid/user/invoices/${id}/download`, {
                    params: {
                        connector_reservation_id:
                            context.state.connector_reservation_id
                    }
                })
                .then(data => {
                    var docUrl = document.createElement("a");
                    docUrl.href = data.url;
                    docUrl.target = "_blank";
                    docUrl.setAttribute("download", `${id}.pdf`);
                    document.body.appendChild(docUrl);
                    docUrl.click();
                });
        }
    },
    mutations: {
        SET_INVOICES(state, data) {
            state.invoices = data;
        },
        SET_CONNECTOR_ID(state, id) {
            state.connector_reservation_id = id;
        }
    }
};
